<template>
  <div>
    <div>
      <div class="tw-bg-white tw-shadow tw-border-t tw-border-gray-200">
        <base-content class="tw-pb-0">
          <div class="tw-flex tw-items-center">
            <h1 class="tw-text-xl sm:tw-text-2xl md:tw-text-3xl tw-leading-tight tw-text-gray-900 tw-mb-0 tw-font-thin">Reports</h1>
          </div>
          <base-tabs class="tw-mt-2 tw-pb-4 md:tw-pb-0 tw-mb-0" no-border @click="tabClick($event)">
            <base-tab v-for="tab in reports" :key="tab.route" :selected="currentComponent === tab.component" :title="tab.title" />
          </base-tabs>
        </base-content>
      </div>
      <base-content>
        <keep-alive>
          <component :is="currentComponent" :business-id="businessId" />
        </keep-alive>
      </base-content>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { capitalize } from "lodash";

export default {
  name: "BusinessReportsView",
  components: {
    BusinessRevenueReport: () => import("@/views/business/reports/revenue/BusinessRevenueReport"),
    BusinessCreditsReport: () => import("@/views/business/reports/credits/BusinessCreditsReport"),
    BusinessMemberChargesReport: () => import("@/views/business/reports/charges/BusinessMemberChargesReport"),
    MemberPlansReport: () => import("@/views/business/reports/plans/MemberPlansReport"),
    BusinessTaxReport: () => import("@/views/business/reports/tax/BusinessTaxReport"),
    BusinessTipReport: () => import("@/views/business/reports/tips/BusinessTipReport"),
    BusinessPrescriptionsReport: () => import("@/views/business/reports/prescriptions/BusinessPrescriptionsReport"),
  },
  props: {
    businessId: String,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("organization", ["organization"]),
    ...mapGetters("role", ["isPredictile", "isBusinessManagement", "isLocationFiltered"]),
    currentComponent() {
      return this.$route.meta.component;
    },
    reports() {
      const reports = [];
      if (this.isPredictile() || this.isBusinessManagement(this.organization.id)) {
        reports.push({ title: "Revenue", route: `/businesses/${this.businessId}/reports/revenue`, component: "BusinessRevenueReport" });
      }

      if (this.organization.usePrescriptionProgramSetting === true)
        reports.push({ title: "Prescriptions", route: `/businesses/${this.businessId}/reports/prescriptions`, component: "BusinessPrescriptionsReport" });

      reports.push(
        {
          title: `${capitalize(this.organization.customerLabelSingular)} Charges`,
          route: `/businesses/${this.businessId}/reports/charges`,
          component: "BusinessMemberChargesReport",
        },
        { title: `${capitalize(this.organization.customerLabelSingular)} Plans`, route: `/businesses/${this.businessId}/reports/plans`, component: "MemberPlansReport" },
      );
      if (this.organization.useCreditsSetting === true)
        reports.push({ title: "Credits", route: `/businesses/${this.businessId}/reports/credits`, component: "BusinessCreditsReport" });

      if (this.isPredictile() || this.isBusinessManagement(this.organization.id)) {
        if (this.organization.hasTaxBasedBusinessPlans === true)
          reports.push({ title: "Sales Tax", route: `/businesses/${this.businessId}/reports/tax`, component: "BusinessTaxReport" });

        if (this.organization.useTipsSetting === true) reports.push({ title: "Tips", route: `/businesses/${this.businessId}/reports/tip`, component: "BusinessTipReport" });
      }

      return reports;
    },
  },
  created() {
    this.getSettings();
  },
  methods: {
    tabClick(tabTitle) {
      const tab = this.reports.find((t) => t.title === tabTitle);
      if (this.currentComponent != tab.component) this.$router.push({ path: `${tab.route}` });
    },
    getSettings() {
      this.$axios.get(`/businesses/${this.businessId}/reports/settings`).then((res) => {
        this.hasTaxedPlans = res.data.hasTaxedPlans;
        this.hasTipSetting = res.data.hasTipSetting;
      });
    },
  },
};
</script>
